import {useContext} from 'react';
import useWindowSize from '@Hooks/useWindowSize';
import {EditorViewport, FORM_MAKER_NAV_COMPACT_BREAKPOINT_PX} from '@FormMakerReact/form-maker.types';
import {formMakerContext} from '@FormMakerReact/form-maker.context';

export function useIsFormMakerNavCompact(): boolean {
  const {state} = useContext(formMakerContext);
  const {windowWidth} = useWindowSize();
  return state.editorViewport !== EditorViewport.DESKTOP || windowWidth <= FORM_MAKER_NAV_COMPACT_BREAKPOINT_PX;
}
